import React from "react";
import { Tooltip, Icon } from 'antd';

function IconHelper({title}){
    return(
        <Tooltip 
            title={title}
        >
            <Icon 
                type="question-circle-o" 
                style={{fontSize: 15}}
            />
        </Tooltip>
    )
}

export default IconHelper;


// WEBPACK FOOTER //
// ./src/components/common/IconHelper.jsx